import { render, staticRenderFns } from "./LoginSignUpPage.vue?vue&type=template&id=a92d85d4&scoped=true&"
import script from "./LoginSignUpPage.vue?vue&type=script&lang=js&"
export * from "./LoginSignUpPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginSignUpPage.vue?vue&type=style&index=0&id=a92d85d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92d85d4",
  null
  
)

export default component.exports